/*eslint-disable*/
import api from '../'

class TicketMessageApi {

    // POST: message
    static create (message) {
        return api.axios.post('/ticket-message', message)
            .then(response => response.data.message);
    }

    // GET: messages
    static list(params, cancelToken = null) {
        return api.axios.get('/ticket-message', {params, cancelToken})
            .then(response => response.data);
    }

}

export default TicketMessageApi;
